import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { ENABLE_ROADMAP } from '../../config/constants';
import { useAuth } from '../../contexts/AuthContext';

const {
  FiHome,
  FiInbox,
  FiTrello,
  FiMap,
  FiSettings,
  FiLogOut,
  FiShield,
  FiLifeBuoy,
  FiHelpCircle,
} = FiIcons;

const Sidebar = ({ activeView, onViewChange, onLogout }) => {
  const { isAdmin, user } = useAuth();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: FiHome },
    { id: 'inbox', label: 'Inbox', icon: FiInbox },
    { id: 'kanban', label: 'Kanban', icon: FiTrello },
    ...(ENABLE_ROADMAP ? [{ id: 'roadmap', label: 'Roadmap', icon: FiMap }] : []),
    { id: 'help', label: 'Help Center', icon: FiHelpCircle },
    ...(isAdmin ? [{ id: 'admin', label: 'Admin', icon: FiShield }] : []),
    { id: 'settings', label: 'Settings', icon: FiSettings },
  ];

  const displayName = user?.name || user?.email || 'Support User';
  const role = user?.role || (isAdmin ? 'Admin' : 'Agent');

  return (
    <aside className="desktop-sidebar sidebar-shell w-64 flex flex-col h-full shrink-0">
      <div className="px-5 py-5 sidebar-divider">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center shadow-sm shrink-0">
            <SafeIcon icon={FiLifeBuoy} className="w-5 h-5 text-surface" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-semibold tracking-[0.16em] uppercase sidebar-muted">BPA Solutions</p>
            <h1 className="text-base font-bold leading-tight text-surface">Support Hub</h1>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-5 space-y-1.5 overflow-y-auto">
        {menuItems.map((item) => {
          const isActive = activeView === item.id;
          return (
            <motion.button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`sidebar-nav-item ${isActive ? 'sidebar-nav-item-active' : ''}`}
              whileTap={{ scale: 0.985 }}
            >
              <SafeIcon icon={item.icon} className="w-5 h-5 shrink-0" />
              <span className="font-medium">{item.label}</span>
              {isActive && <span className="ml-auto w-1.5 h-1.5 rounded-full bg-accent" />}
            </motion.button>
          );
        })}
      </nav>

      <div className="p-4 sidebar-divider-top">
        <div className="sidebar-user-card mb-3">
          <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center text-surface text-sm font-bold shrink-0">
            {displayName.slice(0, 2).toUpperCase()}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-surface truncate">{displayName}</p>
            <p className="text-xs sidebar-muted truncate">{role}</p>
          </div>
        </div>

        <motion.button onClick={onLogout} className="sidebar-logout" whileTap={{ scale: 0.985 }}>
          <SafeIcon icon={FiLogOut} className="w-5 h-5" />
          <span className="font-medium">Logout</span>
        </motion.button>
      </div>
    </aside>
  );
};

export default Sidebar;